import { Router, ActivatedRoute, Data } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { WS10GridColumn } from '@vfde-fe/ngx-lib/brix/ws10-grid';
import { WS10Button } from '@vfde-fe/ngx-lib/brix/ws10-button';
import { Ws10Captcha } from '@vfde-fe/ngx-lib/brix/ws10-captcha';
import { WS10TextHeaderModel } from '@vfde-fe/ngx-lib/brix/ws10-text-header';
import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { WS10Notification, NotificationBackground } from '@vfde-fe/ngx-lib/brix/ws10-notification';
import {  NotificationIconState } from '@vfde-fe/ngx-lib/brix/ws10-notification-icon';

import { CAPTCHA_AUT_ID, CAPTCHA_ID, FORM_DETAILS_PAGE_HEADER_ID, MODULES_NAMES, PRIMARY_COLOR, RECTANGLE_SHAPE, TERTIARY_COLOR } from '../../defines/defines';
import { ComponentLoaderService } from 'src/app/shared/services/component-loader/component-loader.service';
import { ComponentItem } from 'src/app/common/models/component-item.interface';
import { FormDetails, FormField, FormInfo } from 'src/app/common/models/form-details.model';
import { ViewContainerDirective } from 'src/app/shared/directives/view-container/view-container.directive';
import { FormSubmissionService } from 'src/app/shared/services/form-submission/form-submission.service';
import { GenericMessageService } from 'src/app/shared/services/generic-message/generic-message.service';
import { SUCCESS_ICON, FORM_EDITOR_GRID_COLUMN, FILE_FIELD_KEY, CHECK_FILE_UPLOAD_MANDATORY, CHECK_FILE_UPLOAD_OPTIONAL } from 'src/app/common/constants/Defines';
import { FormTracking, TrackingService } from '@vfde-fe/ngx-lib/plugins/tracking';
import { RouterService } from 'src/app/shared/services/router.service';
import { FORM_CENTER_NAME, TRACKING_FORM } from '../../defines/tracking.defines';
import { SharedDataTriggerService } from 'src/app/shared/services/shared-data-in-form-center/shared-data-trigger.service';

/** FormEditorComponent */
@Component({
  selector: 'form-editor',
  templateUrl: './form-editor.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FormEditorComponent implements OnInit ,AfterViewInit{

  /** form */
  public form: FormGroup;

  /** All dynamicComponents including paragraphs, headlines, text inputs ... */
  public dynamicComponents: ComponentItem[];

  /** Form Fields that the user can change it's value */
  public formFields: ComponentItem[];

  /** gridContainerConfig */
  public gridColumnConfig: WS10GridColumn;

  /** captchaConfig */
  public captchaConfig: Ws10Captcha;

  /** submitBtnConfig */
  public submitBtnConfig: WS10Button;

  /** backBtnConfig */
  public backBtnConfig: WS10Button;

  /** formInfo */
  public formInfo: FormInfo;


  /** headlineConfig */
  public textHeaderConfig: WS10TextHeaderModel;

  /** deWordingPath */
  public deWordingPath: string;

  /** noFieldsReturned */
  public noFieldsReturned = false;

  /** xCaptcha */
  public xCaptchaHash: string;

  /** captchaError */
  public captchaError = false;

  /** captchaErrorNotification */
  public captchaErrorNotification: WS10Notification;

  /** fieldsPlaceholder */
  @ViewChild(ViewContainerDirective) public fieldsPlaceholder: ViewContainerDirective;

 /**
  *
  * @param ts
  * @param router
  * @param route
  * @param componentLoaderService
  * @param formBuilder
  * @param formSubmissionService
  * @param genericMessageService
  * @param trackingService
  * @param SharedDataTriggerService
  * @param routerService
  */
  public constructor (
    public ts: TranslateService,
    public router: Router,
    public route: ActivatedRoute,
    public componentLoaderService: ComponentLoaderService,
    public formBuilder: FormBuilder,
    public formSubmissionService: FormSubmissionService,
    public genericMessageService: GenericMessageService,
    public trackingService: TrackingService,
    public sharedDataTriggerService: SharedDataTriggerService,
    private routerService: RouterService,
  ) {
     /** setCurrentModule */
     routerService.setCurrentModule(MODULES_NAMES.app);
  }

  /** ngOnInit */
  public ngOnInit (): void {
    this.deWordingPath = 'FromCenterModule.';
    this.route.data.subscribe((data: Data) => {
      const formDetails: FormDetails = data['formDetails'];
      if (
        formDetails &&
        formDetails.formInfo &&
        formDetails.formFields &&
        formDetails.formFields.length !== 0
      ) {
        this.noFieldsReturned = false;
        this.formInfo = formDetails.formInfo;
        // create form
        this.createForm();
        // Subscribe to callObservableTrigger
        this.callObservableTrigger();
        // make upload file mandatory
        if (formDetails.fileUpload === CHECK_FILE_UPLOAD_MANDATORY) {
          this.sharedDataTriggerService.updateVisibleUploadStatus(true);
          this.form.get('fileUpload')?.setValidators([Validators.required]);
        } else if (formDetails.fileUpload === CHECK_FILE_UPLOAD_OPTIONAL){
          this.sharedDataTriggerService.updateVisibleUploadStatus(true);
        }
        this.configureSharedComponents();
        this.retreiveDynamicComponents(formDetails.formFields);
        this.updateFormStatus(formDetails.formInfo ? false : true);
      } else {
        this.noFieldsReturned = true;
      }
    });

    /** fire tracking  */
    this.trackingPageView();

  }

  private callObservableTrigger (){
     // Subscribe to upload status changes
     this.sharedDataTriggerService.uploadStatus$.subscribe((status: boolean) => {
      this.updateFormStatus(status);
    });
    this.sharedDataTriggerService.shareFilesUploaded$.subscribe((file: string[]) => {
      this.addFilesToForm(file);
    });
  }

  /**
   * trackingPageView
   * @description update number of site structure to be form id and fire handleFormTracking method
   * @returns void
   */
  private trackingPageView (): void {

    /** Update Site Structer  */
    TRACKING_FORM.FORMEDITOR.START_SITE_STRUCTURE[3] = String(FORM_CENTER_NAME + this.formInfo.id);

    /** startTracking */
    this.handleFormTracking(TRACKING_FORM.FORMEDITOR.START_SITE_STRUCTURE, String(FORM_CENTER_NAME + this.formInfo.id), TRACKING_FORM.FORMEDITOR.oForm.FORM_STEP1, TRACKING_FORM.FORMEDITOR.oForm.START_FORM_STEP_NAME, TRACKING_FORM.FORMEDITOR.oForm.START.STATUS);
  }

  /**
   * handleFormTracking
   * @description handle dynamic and static values before fire ngx-module trackForm
   * @param siteStructure
   * @param name
   * @param formStep
   * @param formStepName
   * @param formStatus
   * @param type
   * @returns void
   */
   public handleFormTracking (siteStructure: string[], formId: string, formStep: string, formStepName:string, formStatus:string[]): void {
    /** form tracking */
    const formtracking: FormTracking = {
      siteArea: TRACKING_FORM.FORMEDITOR.SITE_AREA,
      pageType: TRACKING_FORM.FORMEDITOR.PAGE_TYPE,
      platformType: TRACKING_FORM.FORMEDITOR.PLATFORM_TYPE,
      loginStatus: TRACKING_FORM.FORMEDITOR.LOGIN_STATUS,
      siteStructure: siteStructure,
      oForm: {
        name: formId,
        formStep: formStep,
        formStepName: formStepName,
        formStatus: formStatus,
        type: TRACKING_FORM.FORMEDITOR.FORM_TYPE,
      },
    };
    this.trackingService.trackForm(formtracking, MODULES_NAMES.app);
  }

  /** ngAfterViewInit */
  public ngAfterViewInit (): void {
    if (this.dynamicComponents && !this.noFieldsReturned) {
      this.renderDynamicComponents();
      this.listenToFormStatus();
    }
  }

  /** retreiveDynamicComponents
   * @method retreiveDynamicComponents
   * @param formFields: FormFields[]
   * @returns null
   */
  public retreiveDynamicComponents (formFields: FormField[]) {
    this.componentLoaderService.configureDynamicComponents(formFields);
    this.dynamicComponents = this.componentLoaderService.dynamicComponents;
  }

  /** renderDynamicComponents
   * @method renderDynamicComponents
   * @returns null
   */
  public renderDynamicComponents () {
    if (this.fieldsPlaceholder) {
      for (const dynamicComponent of this.dynamicComponents) {
        const componentRef = this.fieldsPlaceholder.viewContainerRef.createComponent(dynamicComponent.component);
        if (dynamicComponent.formField) {
          componentRef.instance['formField'] = dynamicComponent.formField;
          componentRef.instance['form'] = this.form;
        }
      }
    }

  }

  /** createForm
   * @method createForm
   * @param
   * @returns
   */
  public createForm () {
    this.form = this.formBuilder.group({captcha: ['']});
  }

  /** configureSharedComponents
   * @method configureSharedComponents
   * @returns {void} void
   */
  public configureSharedComponents (): void {
    /** Grid system */
    this.gridColumnConfig = FORM_EDITOR_GRID_COLUMN;

    /** Page heading */
    if (this.formInfo.name) {
      this.textHeaderConfig = {
        automation_id: FORM_DETAILS_PAGE_HEADER_ID,
        headlineText: this.formInfo.name,
      };
    }

    /** captcha */
    this.captchaConfig = {
      id: CAPTCHA_ID,
      automation_id: CAPTCHA_AUT_ID,
      helperText: this.ts.instant(this.deWordingPath + 'formRendering.captcha.helperText.std-headline'),
    };

    /** submit button */
    this.submitBtnConfig = {
      color: PRIMARY_COLOR,
      shape: RECTANGLE_SHAPE,
      content: this.ts.instant(this.deWordingPath + 'formRendering.submitBtn.std-headline'),
      disabled: this.form.invalid,
    };

    /** back button */
    this.backBtnConfig = {
      color: TERTIARY_COLOR,
      shape: RECTANGLE_SHAPE,
      content: this.ts.instant(this.deWordingPath + 'formRendering.backBtn.std-headline'),
    };

    /** captcha error notification */
    this.captchaErrorNotification = {
      state: NotificationIconState.ERROR,
      background: NotificationBackground.TRANSPARENT,
      headline: this.ts.instant(this.deWordingPath + 'formSubmit.captchaFailure.std-headline'),
      content: this.ts.instant(this.deWordingPath + 'formSubmit.captchaFailure.std-subHeadline'),
      notificationIcon: {
        state: NotificationIconState.ERROR,
      },
    };
  }

  /** onSubmit
   * @method onSubmit
   * @returns void
   */
  public onSubmit () {

    this.formSubmissionService
      .submit(this.formInfo.id, this.form.controls, this.xCaptchaHash)
      .subscribe(() => {
        this.navigateToSuccessPage();
        /**  update site Structer number to be form id */
        TRACKING_FORM.FORMEDITOR.CONFIRMATION_SITE_STRUCTURE[3] = String(FORM_CENTER_NAME + this.formInfo.id);
        /** fire handleFormTracking as successTracking */
        this.handleFormTracking(TRACKING_FORM.FORMEDITOR.CONFIRMATION_SITE_STRUCTURE, String(FORM_CENTER_NAME + this.formInfo.id), TRACKING_FORM.FORMEDITOR.oForm.FORM_STEP2,TRACKING_FORM.FORMEDITOR.oForm.CONFIRMATION_FORM_STEP_NAME, TRACKING_FORM.FORMEDITOR.oForm.SUCCESS.STATUS);
      },
      () => {
        this.configureCaptchaError();
        /** check validation error to fire the tracking error */
        if (!this.captchaError) {
          /** update site Structer number to be form id */
          TRACKING_FORM.FORMEDITOR.CONFIRMATION_SITE_STRUCTURE[3] = String(FORM_CENTER_NAME + this.formInfo.id);
          /** fire handleFormTracking as errorTracking */
          this.handleFormTracking(TRACKING_FORM.FORMEDITOR.CONFIRMATION_SITE_STRUCTURE, String(FORM_CENTER_NAME + this.formInfo.id), TRACKING_FORM.FORMEDITOR.oForm.FORM_STEP2,TRACKING_FORM.FORMEDITOR.oForm.CONFIRMATION_FORM_STEP_NAME, TRACKING_FORM.FORMEDITOR.oForm.FAILURE.STATUS);
        }
      });
  }

  /** onBackBtnClick
   * @method onBackBtnClick to navigate to hub page
   * @returns {void} void
   */
   public onBackBtnClick (): void {
    const url = [this.ts.instant(this.deWordingPath + 'formRendering.backBtn.link-href')];
    this.router.navigate(url);
  }

  /**
   * updateFormStatus
   * @description check upload file status for disable send btn
   * @param formStatus boolean
   */
  public updateFormStatus (uploadedSuccess: boolean): void {
    // Dynamically add 'uploadField' control to the form if not already present
    if (!this.form.contains('fileUpload')) {
      this.form.addControl('fileUpload', this.formBuilder.control(''));
    }
    // Get the form control
    const fileUpload = this.form.get('fileUpload');

    if (!fileUpload) {
      return;
    }

    // If upload is unsuccessful, mark the form as invalid with 'uploadFailed' error {false case}
    if (!uploadedSuccess) {
      fileUpload.setErrors({ uploadFailed: true });
      this.form.markAsTouched();
    } else {
      // If upload is successful, Remove the 'uploadFailed' error, marking it as valid
      fileUpload.setErrors(null);
      this.form.markAsPristine();
      // Remove the 'fileUpload' form control from the form if everything is okay
      this.form.contains('fileUpload') && this.form.removeControl('fileUpload');
    }
  }

  /**
   * addFilesToForm
   * @description check upload files encoded
   * @param formStatus boolean
   */
  public addFilesToForm (uploadFiles: string[]): void {
    if (!this.form.contains(FILE_FIELD_KEY)) {
      // Initialize as an empty array
      this.form.addControl(FILE_FIELD_KEY, this.formBuilder.control([]));
    }

    const fileUploadControl = this.form.get(FILE_FIELD_KEY);

      // If files are uploaded, store the File objects in the form control
      fileUploadControl.setValue(uploadFiles);
      fileUploadControl.setErrors(null);
      this.form.markAsPristine();
  }

  /** listenToFormStatus
   * @method listenToFormStatus
   * @description to change the submit button config when the form is valid or invalid
   * @returns {void} void
   */
  public listenToFormStatus (): void {
    this.form.statusChanges.subscribe(() => {
      this.submitBtnConfig = {...this.submitBtnConfig, disabled: this.form.invalid || !this.form.controls['captcha'].value};
    });
  }

  /** onCaptchaLoad
   * @method onCaptchaLoad to store xCaptcha when emitted
   * @returns {void} void
   */
  public onCaptchaLoad (xCaptchaHash): void {
    this.xCaptchaHash = xCaptchaHash;
  }

  /** navigateToSuccessPage
   * @method navigateToSuccessPage to navigate to success page when the form is submitted
   * @returns {void} void
   */
  public navigateToSuccessPage (): void {
    this.genericMessageService.successMessage = {
      iconName: SUCCESS_ICON,
      headline: this.ts.instant(this.deWordingPath + 'formSubmit.success.std-headline'),
      text: this.formInfo.confirmationText ? this.formInfo.confirmationText : this.ts.instant(this.deWordingPath + 'formSubmit.success.std-subHeadline'),
      innerLink: {
        text: this.ts.instant(this.deWordingPath + 'formSubmit.success.backBtn.std-headline'),
        url: this.ts.instant(this.deWordingPath + 'formSubmit.success.backBtn.link-href'),
      },
    };
    const url = ['/resultat'];
    this.router.navigate(url);
  }

  /** configureCaptchaError
   * @method configureCaptchaError
   * @description to set the form control to invalid due to backend validation
   * @returns {void} void
   */
  public configureCaptchaError (): void {
    this.captchaError = true;
    this.captchaConfig = {...this.captchaConfig, backEndValidationError: true};
    this.form.controls['captcha'].setValue('');
    setTimeout(() => {
      this.captchaConfig = {...this.captchaConfig, backEndValidationError: false};
    });
  }

}
